import {GatewayCommunicationRequestNames} from '@constants/administration/gateway/gateway-communication.enums';

export class GatewayCommunicationRequest {
  requestName: string = GatewayCommunicationRequestNames.I_CONN_UNIVERSAL;
  configurationRequest: boolean = true;
  timestamp: number = Math.floor(new Date().getTime() / 1000);
  servicePerformed: boolean = false;
  offsetHours: number | null = null;
  serviceInterval: number | null = null;
}

